/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Fit_Files_TitleInputs */

const en_ui_fit_files_title = /** @type {(inputs: Ui_Fit_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIT files`)
};

const de_ui_fit_files_title = /** @type {(inputs: Ui_Fit_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIT-Dateien`)
};

/**
* | output |
* | --- |
* | "FIT files" |
*
* @param {Ui_Fit_Files_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_fit_files_title = /** @type {((inputs?: Ui_Fit_Files_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Fit_Files_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_fit_files_title(inputs)
	return de_ui_fit_files_title(inputs)
});